import {
  ProviderCredential,
  ProviderLicense,
} from "../../../domain/Provider/schema"

export const filterExpiredLicenses = (
  providerLicenses: ProviderLicense[],
): ProviderLicense[] => {
  return providerLicenses.filter(
    ({ licenseStatusDisplayId }) => licenseStatusDisplayId !== "expired",
  )
}

export const filterExpiredCredentials = (
  credentials: ProviderCredential[],
): ProviderCredential[] => {
  const currentDate = new Date()

  return credentials.filter((credential) => {
    const expireDate = credential.expireDate
      ? new Date(credential.expireDate)
      : null
    return expireDate instanceof Date && expireDate > currentDate
  })
}
